// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"152":"5d9e3cabad323bbf","185":"cf42d63707c450df"}[chunkId] + ".css";
};